import { Breadcrumbs, Link, Typography, Box } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import React from 'react';

export interface Crumb {
  label: string | React.ReactNode;
  to?: { pathname: string; state?: any };
}

interface Props {
  items: Crumb[];
}

const PageBreadcrumbs: React.FC<Props> = ({ items }) => {
  const location = useLocation();
  const navigate = useNavigate();

const rootCrumb: Crumb = {
    label: (
      <Box
        component="img"
        src="/shootingData/aim.svg"
        alt="Sessions"
        sx={{
          width: 20,
          height: 20,
          filter:
            'invert(76%) sepia(1%) saturate(0%) hue-rotate(174deg) brightness(88%) contrast(92%)',
          display: 'inline',
          position: 'relative',
          top: '1.5px',
          mr: 0.5,
        }}
      />
    ),
    to: { pathname: '/client-admin/shooting-data' },
  };

  const allItems = [rootCrumb, ...items];

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: '#0B0F12',
        py: 1.5,
        px: 3,
        display: 'flex',
        alignItems: 'center',
        borderBottom: '1px solid #1D2935',
      }}
    >
      <Breadcrumbs separator="›" aria-label="breadcrumb" sx={{ color: 'white' }}>
        {allItems.map((item, index) =>
          item.to ? (
            <Link
              key={index}
              component="button"
              underline="hover"
              color="inherit"
              onClick={() => {
                const isSamePath = item.to!.pathname === location.pathname;
                navigate(item.to!.pathname, {
                  state: item.to!.state,
                  replace: isSamePath,
                });
              }}
              sx={{ fontSize: '0.9rem', color: '#ccc' }}
            >
              {item.label}
            </Link>
          ) : (
            <Typography key={index} color="white" fontSize="0.9rem">
              {item.label}
            </Typography>
          )
        )}
      </Breadcrumbs>
    </Box>
  );
};

export default PageBreadcrumbs;
